import { useMutation } from "@tanstack/react-query";

import { submitSurveyResponses } from "@/modules/session-survey/services/submitSurveyResponses";
import { SurveyResponse } from "@/modules/session-survey/types/SurveyResponse";

export const useSessionSurveyMutation = (
  surveyId: string,
  options: { onSuccess: () => void; onError: () => void },
  submitResponses: typeof submitSurveyResponses = submitSurveyResponses,
) =>
  useMutation({
    mutationFn: (responses: SurveyResponse[]) =>
      submitResponses(surveyId, responses),
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
